// removed by extract-text-webpack-plugin
module.exports = {"horizontalScroller":"src-components-HorizontalScroller-__HorizontalScroller-module___horizontalScroller","childrenContainer":"src-components-HorizontalScroller-__HorizontalScroller-module___childrenContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HorizontalScroller/HorizontalScroller.module.css
// module id = 979
// module chunks = 0